export default "__VITE_ASSET__Djul7i8s__"